import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Template } from 'src/app/models/communication/template';
import { DataService } from 'src/app/services/data.service';
import { SiteService } from 'src/app/services/site.service';

@Component({
  selector: 'app-templates',
  templateUrl: './templates.component.html',
  styleUrls: ['./templates.component.scss']
})
export class TemplatesComponent {

	public templates: Array<Template> = [];

	constructor(private dataService: DataService, private siteService: SiteService, private router: Router) { }

	ngOnInit() {
		this.siteService.pageTitle = 'Templates';
		this.dataService.getTemplates().subscribe((data) => {
			this.templates = data;
		});
		this.siteService.headerButtons = [
			{ text: 'Add New', class: 'success', callback: () => this.addNew() },
		];
	}

	addNew() {
		this.router.navigate(['/admin/campaigns/templates/new']);
	}
}
